'use client';

import type { FC, HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

export const InfoCard: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
  <div
    className={cn('rounded-xl border border-separator-opaque bg-bg-secondary p-5', className)}
    {...props}
  >
    {children}
  </div>
);
